import React from 'react';
import {ICRSDetails, ICRSOutline} from "../interfaces";
import {getJSONFromHtml} from "../../../../domain/common";
import CRSDataDetails from "../src-data-details/src-data-details";
import {GrouAndSortOutlineList} from "./src-outline-helper";
import CRSOutlineLi from "./src-outline-li";
import CRSOutlineBoxMessage from "./src-outline-message-box";


/**
 * the entry point
 */
const CRSOutline = () => {


        const crsOutline = getJSONFromHtml(document.getElementById('crs-outline')) as ICRSOutline[];
        if(!crsOutline)
            return <></>;
        const crsDetails = getJSONFromHtml(document.getElementById('crs-info')) as ICRSDetails;

        let groupedArr = GrouAndSortOutlineList(crsOutline);


        return(
            <div className="flex flex-wrap flex-col justify-start w-full py-20">
                <div className="waves-h2 mt-0 pb-4 md:pb-8 text-center waves-box-sm mx-auto">Full Course Outline</div>
                {crsDetails != null &&
                    <dl className="pb-10">
                        <CRSDataDetails
                            courseDurationHours={crsDetails.courseDurationHours}
                            numberOfLessons={crsDetails.numberOfLessons}
                            numberOfPlugins={crsDetails.numberOfPlugins}
                            colorIcons="#000000"
                            classNameEx="text-base justify-center"/>
                    </dl>
                }
                {crsDetails.includesFoundation && <CRSOutlineBoxMessage />}

                    <div className="w-full border border-gray-200 rounded">
                        {groupedArr && Object.values(groupedArr).map((group, key) => {

                            return (
                                    <CRSOutlineLi key={key} crsOutlineLi={group as []} groupsCount={ Object.keys(groupedArr).length} />
                            )
                        })}
                    </div>

            </div>

        );

};

export default CRSOutline;